/**
 * MIPL GLOBAL logo component.
 * Renders the official brand mark plus an optional wordmark.
 *
 * The wordmark uses the rounded `.font-brand` (Quicksand) typeface that matches
 * the lowercase "mipl global" text inside the logo artwork itself, so the
 * lockup feels visually unified.
 */
export default function Logo({ size = 32, showWordmark = true, className = "", tone = "dark", tagline = true }) {
  const wordmarkCls = tone === "light" ? "text-white" : "text-zinc-900";
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src="/mipl-logo.jpeg"
        alt="MIPL GLOBAL"
        width={size}
        height={size}
        className="rounded-md object-contain flex-shrink-0"
        style={{ width: size, height: size }}
      />
      {showWordmark && (
        <div className="flex flex-col leading-none">
          <span className={`font-brand font-bold ${wordmarkCls}`}
                style={{ fontSize: Math.max(size * 0.46, 14), lineHeight: 1 }}>
            mipl global
          </span>
          {tagline && (
            <span className="text-[9px] font-mono uppercase tracking-[0.22em] text-zinc-400 mt-1">
              Brand &amp; spatial communication
            </span>
          )}
        </div>
      )}
    </div>
  );
}
